import { makeStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import SendIcon from '@material-ui/icons/Send';
import Alert from '@material-ui/lab/Alert';
import React, { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import { reSubmitTask } from '../../../api/task';
import { ApiContext } from '../../../contexts/ApiContext';
import { getDate } from '../../../utils/transformer';
import { useSnackBar } from '../../Common/SnackBarContext';
import { ReactHookFormDatePicker } from '../Form';

const useStyles = makeStyles((theme) => ({
  title: {
    margin: theme.typography.h1,
  },
  ketentuan: {
    margin: theme.spacing(3, 0),
  },
  img: {
    width: '20%',
    margin: 'auto',
  },
}));

const DatePickTask = ({ taskResponse }) => {
  const classes = useStyles();
  const { handleSubmit, errors, control } = useForm({
    mode: 'onBlur',
  });
  const snackBarHelper = useSnackBar();
  const [isSendable, setIsSendable] = useState(true);

  const apiContext = useContext(ApiContext);

  const onSubmit = async (data) => {
    snackBarHelper.openSnackBar('info', 'Mengirim...');
    setIsSendable(false);
    try {
      const sub = await reSubmitTask(
        apiContext.axios,
        taskResponse?.id,
        taskResponse?.task?.id,
        data[taskResponse?.task.name]
      );
      if (sub) {
        snackBarHelper.openSnackBar('success', 'Permintaan dikirim');
      }
    } catch (err) {
      snackBarHelper.openSnackBar('error', err.toString());
    }
    setIsSendable(true);
  };

  return (
    <>
      <h2 className={''}>{taskResponse?.name}</h2>
      <form onSubmit={handleSubmit(onSubmit)}>
        <ReactHookFormDatePicker
          key={taskResponse?.task.name}
          // type={taskResponse?.task.widget_parameters.type}
          defaultValue={taskResponse?.response}
          attr={taskResponse?.task.name}
          rules={taskResponse?.task.widget_parameters.rules}
          control={control}
          shrink={true}
          error={errors[taskResponse?.task.name]}
          fullWidth
          disabled={taskResponse?.status === 'ACCEPTED'}
        />
        <div className={classes.ketentuan}>
          <div className={''}>{taskResponse?.task?.description}</div>
          <div>
            Status submisi Anda adalah{' '}
            <strong>{String(taskResponse?.status).toLowerCase()}</strong>
            <div>
              Submisi dilakukan pada {getDate(taskResponse?.last_submitted_at)}{' '}
            </div>
          </div>
        </div>
        <div id="simpan" className="mt-4">
          {taskResponse?.status !== 'ACCEPTED' ? (
            <Button
              variant="contained"
              type="button"
              color="secondary"
              startIcon={<SendIcon />}
              disabled={!isSendable}
              onClick={handleSubmit(onSubmit)}
            >
              {taskResponse?.status === 'CANCELLED' ? 'PERBAIKI' : 'PERBARUI'}
            </Button>
          ) : (
            <h3>Terima Kasih</h3>
          )}
          <Collapse in={!isSendable}>
            <Alert elevation={6} variant="filled" severity="info">
              Harap tetap di laman ini selama formulir Anda dikirim
            </Alert>
          </Collapse>
        </div>
      </form>
    </>
  );
};

export default DatePickTask;
